<template>
  <main class="legal">
    <div class="container">
      <router-link
        class="legal__back"
        to="/"
      >← {{ data.legal.backLabel }}</router-link>
      <h1 class="legal__title">{{ data.legal.title }}</h1>
      <section
        v-for="section in data.legal.sections"
        :key="section.title"
        class="legal__section"
      >
        <h2>{{ section.title }}</h2>
        <p>{{ section.body }}</p>
      </section>
    </div>
  </main>
</template>

<script>
export default {
  name: 'LegalView',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.legal {
  background: $white;
  padding: 60px 0 90px;
  min-height: 60vh;
}

.legal__back {
  display: inline-block;
  margin-bottom: 26px;
  font-size: 13px;
  font-weight: 600;

  &:hover {
    color: $cyan;
  }
}

.legal__title {
  font-size: clamp(26px, 3vw, 36px);
  font-weight: 700;
  color: $blue;
}

.legal__section {
  margin-top: 32px;

  h2 {
    font-size: 20px;
    font-weight: 700;
    color: $navy;
    margin-bottom: 8px;
  }

  p {
    line-height: 1.7;
    font-size: 14.5px;
  }
}
</style>
